import {
  Tooltip,
  tooltipClasses
} from "@mui/material";
import { styled } from "@mui/styles";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#343A40",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#343A40",
    color: "#FFFFFF",
    padding: "11px 15px",
  },
}))

export default BootstrapTooltip